import React from 'react';

import { SelectHolder, SelectOuterHolder, Label } from './MultiDropDownWrapper.styles';

const MultiDropDownWrapper = (props) => {
  const { selectedIdList, label, className } = props;
  const makeBig = selectedIdList && selectedIdList.length;

  return (
    <SelectOuterHolder className={className} makeBig={makeBig}>
      {label && <Label makeBig={makeBig}>{label}&nbsp;</Label>}
      <SelectHolder makeBig={makeBig}>{props.children}</SelectHolder>
    </SelectOuterHolder>
  );
};

export default MultiDropDownWrapper;
